import Vue from 'vue';
import * as types from './mutation-types'

const mutations = {
    [types.CLEAR_BALANCE_SUMMARY](state) {
        state.balanceSummary = {};
    },
    [types.CLEAR_FA_CLIENT](state) {
        if (state.user && state.user.applicants) {
            state.user.applicants = state.user.applicants.filter(app => app.type !== "test");
        }
    },
    [types.CLEAR_OPTION_COMBO](state) {
        state.optionCombo = {};
    },
    [types.CLEAR_MARKETDATA](state) {
        state.marketData = [];
    },
    [types.CLEAR_NEWS](state) {
        state.news = [];
    },
    [types.CLEAR_NEWS_CONTENT](state) {
        state.newsContent = [];
    },
    [types.CLEAR_PERFORMANCE](state) {
        state.performance = [];
    },
    [types.CLEAR_MODELS](state) {
        state.models = []
    },
    [types.CLEAR_POSITIONS](state, model) {
        const pm = state.positions.find(m => m.name == model);
        if (pm && pm .positions) {
            pm.positions = [];
        }
    },
    [types.CLEAR_PRICE_HISTORY](state) {
        state.priceHistory = [];
    },
    [types.SET_ACCESSIBILITY](state, val) {
        state.accessibility = val;
    },
    [types.SET_AUTH_TOKEN_CREATED](state, val) {
        state.authTokenCreated = val;
    },
    [types.SET_BRAND_INFO](state, info) {
        state.brandInfo = info;
    },
    [types.SET_BALANCE_SUMMARY](state, balanceSummary) {
        state.balanceSummary = balanceSummary;
    },
    [types.SET_FA_CLIENT](state) {
        if (state.user) {
            let applicants = state.user.applicants || [];
            applicants.push({type: 'test', businessType: 'FA_CLIENT'});
            Vue.set(state.user, 'applicants', applicants);
        }
    },
    [types.SET_ALL_ACCOUNTS](state, ids) {
        if (state.allAccounts.length === 0) {
            state.allAccounts = ids;
        }
    },
    [types.SET_SELECTED_ACCOUNTS](state, ids) {
        state.selectedAccounts = ids;
    },
    [types.SET_ACCOUNT_PNL](state, data) {
        state.pnl = data;
    },
    [types.SET_OPTION_COMBO](state, data) {
        state.optionCombo = data;
    },
    [types.SET_COMPETITORS](state, competitors) {
        state.competitors = competitors;
    },
    [types.SET_FROM_MOBILE](state, data) {
        state.fromMobile = data;
    },
    [types.SET_FUNDAMENTALS](state, { conid, data }) {
        if (isNaN(conid) || data === undefined || data.error) {
            return;
        }
        const store = {
            conid: conid,
            data: data
        };
        for (let x = 0; x < state.fundamentals.length; x++) {
            let fundamentals = state.fundamentals[x];
            if (fundamentals.conid == conid) {
                Vue.set(state.fundamentals, x, store);
                return;
            }
        }
        state.fundamentals.push(store);
    },
    [types.SET_MARKETS](state, markets) {
        state.markets = markets;
    },
    [types.SET_MODELS](state, models) {
        let hasMi = false;
        const m = models.filter(model => {
            if (model.name == 'MI.Core' || model.name.indexOf('CP') == 0) {
                return false;
            }
            if (model.name.indexOf('MI') == 0) {
                hasMi = true;
            }
            return true;
        });
        if (hasMi) {
            state.models = m.filter(model => {
                if (model.name == 'MP.Core') {
                    return true;
                }
                if (model.name.indexOf('MI') == 0) {
                    const pmModel = models.find(mp => mp.name == 'MP' + model.name.substr(2));
                    if (pmModel) {
                        model.description = pmModel.description;
                    }
                    return true;
                } else {
                    return false;
                }
            });
        } else {
            state.models = m;
        }
    },
    [types.SET_MARKETDATA](state, { conid, data }) {
        if (isNaN(conid)) {
            return;
        }
        Vue.set(state.marketData, conid, { ...state.marketData[conid], ...data });
    },
    [types.SET_SECDEF_DATA](state, { conid, data }) {
        if (isNaN(conid)) {
            return;
        }
        if (data && data.conid == conid) {
            Vue.set(state.secdefData, conid, { ...state.secdefData[conid], ...data });
        } else {
            console.error('wrong conid', conid, data);
        }
    },
    /**
     * id, headline,
     */
    [types.SET_NEWS](state, { conid, data }) {
        if (isNaN(conid)) {
            return;
        }

        let old = [];
        if (state.news[conid] && state.news[conid].length > 0) {
            old = state.news[conid].slice();
        }

        state.news = {};
        state.news[conid] = data;
        if (old.length === 0) {
            state.newsContent = {}; // we also clear the news content to cleanup memory
            state.news[conid] = data.map(e => { e.show = false; return e });
        } else {
            state.news[conid] = old.concat(data.map(e => { e.show = false; return e }));
        }
    },
    [types.SET_NEWS_CONTENT](state, { newsId, data }) {
        if (!newsId || !data) {
            return;
        }
        state.newsContent[newsId] = data;
    },
    [types.SET_PERFORMANCE](state, performance) {
        state.performance = performance;
    },
    [types.SET_PERIOD](state, period) {
        state.period = period;
    },
    [types.UPDATE_POSITIONS](state, { model, updates }) {
        if (!updates) return;
        const pm = state.positions.find(m => m.name == model);
        if (!pm) return;
        for (let x = 0; x < updates.length; x++) {
            const update = updates[x];
            for (let y = 0; y < pm.positions.length; y++) {
                let position = pm.positions[y];
                if (position.conid == update.conid) {
                    if (update._updated > pm.lastUpdate || pm.lastUpdate === undefined) {
                        Vue.set(pm, 'lastUpdate', update._updated);
                    }
                    Vue.set(pm.positions, y, Object.assign(position, update));
                }
            }
        };
    },
    [types.SET_POSITIONS](state, { model, list }) {
        const obj = state.positions.find(m => m.name == model);
        if (!obj) {
            state.positions.push({
                name: model,
                positions: list
            });
        } else {
            obj.positions = obj.positions.concat(list);
        }
    },
    [types.SET_POSITIONS_TOTAL_NUM](state, { model, num = 0 }) {
        const pm = state.positions.find(m => m.name == model);
        if (pm) {
            pm.total = num;
        }
    },
    [types.SET_PRICE_HISTORY](state, { conid, data }) {
        if (isNaN(conid)) {
            return;
        }
        state.priceHistory = {};
        state.priceHistory[conid] = data;
    },
    [types.SET_RATES](state, rates) {
        state.rates = rates;
    },
    [types.SET_SEARCH_SYM_RESULTS](state, orderInfo) {
        state.orderInfo = orderInfo;
    },
    /**
     * We set the username once the SSO credentials are validated, before the call to /user.
     * we do this as we need the username for many things that need to happen even before we start sending
     * request to the different backends.
     */
    [types.SET_USERNAME](state, username) {
        window.username = username;
        Vue.set(state.user, 'username', username);
    },
    [types.SET_SSO](state, sso) {
        if (!sso) {
            return;
        }
        const faLandingApps = [ 'AM', 'UNIVERSAL', 'PORTAL-AM-US'];
        /**
         * Set IS_MASTER to true if IS_MASTER is true and landing app is 'AM' or 'UNIVERSAL' or 'PORTAL-AM-US'
         * This is temporary fix till AUTHSRVR-862 is resolved
         */
        const isMaster = ((sso.IS_MASTER === true) && (faLandingApps.includes(sso.LANDING_APP)))
                ? true : false;
        state.sso = { ...sso, ...{ IS_MASTER: isMaster }};
    },
    [types.SET_USER](state, user) {
        state.user = user;
        if (process.env.DISABLE_UAR) {
            for (const key in state.user.uar) {
                state.user.uar[key] = true;
            }
        }
    },
    [types.TOGGLE_NEWS_CONTENT](state, i) {
        let content = state.newsContent[i];
        let news = state.news[i];
        news.show = !news.show;
        content.show = !content.show;
    },
    [types.SET_UAR](state, data) {
        state.uar = data;
    },
    [types.REGISTER_EVENT](state, event) {
        const name = event[0];
        const cb = event[1];
        const events = state.events[name];
        if (!events) {
            console.error('event unknown', name, event);
            return;
        }
        if (!cb) {
            console.error('registering event without callback', name, event);
            return;
        }
        events.push(cb);
        if (name == 'ON_UAR_CHANGED') {
            cb(state.user.uar); // dispatch what we have in store.
        }
    },
    [types.TRIGGER_EVENT](state, event) {
        const name = event && event.name;
        if (!name) {
            console.debug('can\'t trigger event without name', event);
            return;
        }

        const callbacks = state.events[name];
        if (!callbacks) {
            console.debug('callback is not documented, add to state', name);
            return;
        }
        callbacks && callbacks.forEach(cb => {
            setTimeout(() => cb({...event}));
        });
    },
    [types.SET_SSO_VALIDATED](state, authenticated) {
        state.ssoValidated = authenticated;
    },
    [types.SET_EVENT_LISTENERS](state, events) {
        events && events.forEach((e) => {
            const key = e[0];
            const cb = e[1];
            if (!state.events[key]) {
                console.debug('unknown event key, ignored: ', key);
                return;
            }
            state.events[key].push(cb);
        })
    },
    [types.SET_SHOW_BASE_CURRENCY](state, val) {
        state.showInBase = val;
    },
    //dev only, for get started
    [types.SET_CLEARING_STATUS](state, val) {
        const accts = state.user.accts;
        const keys = Object.keys(accts);
        accts[keys[0]].clearingStatus = val;
    },
    [types.SET_FIRST_APPROVE_DATE](state, val) {
        state.user.firstApprovedDate = val;
    },
    [types.SET_OPEN_DATE](state, val) {
        const accts = state.user.accts;
        const keys = Object.keys(accts);
        accts[keys[0]].openDate = val;
    },
    [types.TOGGLE_FREE_TRIAL](state, val) {
        Vue.set(state.sso, 'IS_FREE_TRIAL', val);
    },
    [types.TOGGLE_IS_FUNDED](state) {
        const accts = state.user.accts;
        const keys = Object.keys(accts);
        accts[keys[0]].isFunded = !accts[keys[0]].isFunded;
    },
    [types.TOGGLE_SF_ENABLED](state) {
        if (state.sso.SF_ENABLED) {
            Vue.set(state.sso, 'SF_ENABLED', false);
        } else {
            Vue.set(state.sso, 'SF_ENABLED', true);
        }
    },
    [types.SET_WHITE_BRANDING](state, val) {
        state.user.wbId = val;
    },
    [types.SET_FAVICON_URL](state, val) {
        state.faviconUrl = val;
    },
    [types.SET_NOTIFICATION_ICON_URL](state, val) {
        state.notificationIconUrl = val;
    },
    [types.SET_IS_CURRENT_INCOMPLETE_MD](state, val) {
        state.isCurInComMd = val;
    },
    [types.SET_IS_INCOMPLETE_CONID_SELECTED_IN_QUICKTRADE](state, val) {
        state.isInCompleteConidSel = val;
    },
    [types.SET_PICKER_ACCOUNTS](state, val) {
        state.pickerAccounts = val;
    },
    [types.ROUTE_LOADING](state, val) {
        state.routeLoading = val;
    },
    [types.PRIVACY_MODE](state, val) {
        state.privacyMode = val;
    },
    [types.SET_ACCOUNT_PROPERTIES](state, data) {
        state.accountProperties = data;
    },
    [types.SET_AM_STATUS](state, data) {
        state.amStatus = data;
    },
    [types.SET_ACCOUNT_STATUS](state, { res, data }) {
        const accounts = data.acctIds;
        accounts.forEach(account => {
            if(res[account]) {
                if (res[account].POA_TASK === 'PENDING' ||
                    res[account].EDD_TASK === 'PENDING' ||
                    res[account].PEP_TASK === 'PENDING'
                ) {
                    state.isAccountTaskPending = true;
                }
            }
        });
    },
    [types.SET_SHOW_IB_KEY_WIDGET](state, data) {
        state.forceShowIBKeyWidget = data;
    },
    [types.SET_SHOW_CRYPTO_POPOVER](state, data) {
        state.forceShowCryptoPopover = data;
    },
    [types.TOGGLE_TEST_CRYPTO_POS](state) {
        state.isTestingCryptoPos = !state.isTestingCryptoPos;
    }
}

export default mutations;
